import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-bug-line text-2xl ${scrolled || !isHome ? 'text-primary-500' : 'text-white'}`}></i>
            </div>
            <span
              className={`text-xl font-heading transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-white'
              }`}
            >
              虫虫动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? scrolled || !isHome
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith('/category')
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? scrolled || !isHome
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled || !isHome
                    ? 'text-foreground-700 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border transition-all duration-200 outline-none w-48 focus:w-64 ${
                  scrolled || !isHome
                    ? 'bg-background-100 border-background-200 focus:border-primary-300 text-foreground-900 placeholder-foreground-400'
                    : 'bg-white/15 border-white/20 text-white placeholder-white/60 focus:bg-white/25'
                }`}
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className={`ri-search-line text-sm ${scrolled || !isHome ? 'text-foreground-400' : 'text-white/70'}`}></i>
              </div>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-white'
              } ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-2">
            <div className="relative mb-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2.5 rounded-lg text-sm border border-background-200 bg-background-100 text-foreground-900 placeholder-foreground-400 outline-none focus:border-primary-300"
              />
              <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </div>
            </div>
            <Link
              to="/"
              className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}